import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "calendar-picker" }
const _hoisted_2 = { class: "calendar-header" }
const _hoisted_3 = { class: "calendar-month-selector" }
const _hoisted_4 = { class: "selected-month" }
const _hoisted_5 = { class: "calendar-dates-container" }
const _hoisted_6 = { class: "calendar-row day-header" }
const _hoisted_7 = { class: "calendar-row calendar-row-fill" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "dates" }
const _hoisted_10 = { class: "drop-off-date" }
const _hoisted_11 = { class: "date" }
const _hoisted_12 = ["value"]
const _hoisted_13 = {
  key: 0,
  class: "pick-up-date"
}
const _hoisted_14 = { class: "date" }
const _hoisted_15 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          class: "arrow left",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.adjustMonth(-1)))
        }, _cache[4] || (_cache[4] = [
          _createElementVNode("svg", {
            width: "22",
            height: "22",
            viewBox: "0 0 22 22",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, [
            _createElementVNode("path", {
              d: "M0.5 11C0.5 5.20139 5.20139 0.5 11 0.5C16.7986 0.5 21.5 5.20139 21.5 11C21.5 16.7986 16.7986 21.5 11 21.5C5.20139 21.5 0.5 16.7986 0.5 11ZM10.1683 17.5016L15.6683 12.0016C16.222 11.448 16.222 10.552 15.6683 9.99836L10.1683 4.49836C9.61462 3.94468 8.71871 3.94469 8.16503 4.49836C7.61135 5.05204 7.61135 5.94796 8.16503 6.50164L12.6634 11L8.16503 15.4984C7.61135 16.052 7.61135 16.948 8.16503 17.5016C8.4411 17.7777 8.80449 17.9167 9.16667 17.9167C9.52884 17.9167 9.89224 17.7777 10.1683 17.5016Z",
              fill: "white",
              stroke: "#D9D9D9"
            })
          ], -1)
        ])),
        _createElementVNode("span", _hoisted_4, _toDisplayString($setup.Months[$setup.timeframe.month]) + " " + _toDisplayString($setup.timeframe.year), 1),
        _createElementVNode("span", {
          class: "arrow right",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.adjustMonth()))
        }, _cache[5] || (_cache[5] = [
          _createElementVNode("svg", {
            width: "22",
            height: "22",
            viewBox: "0 0 22 22",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, [
            _createElementVNode("path", {
              d: "M0.5 11C0.5 5.20139 5.20139 0.5 11 0.5C16.7986 0.5 21.5 5.20139 21.5 11C21.5 16.7986 16.7986 21.5 11 21.5C5.20139 21.5 0.5 16.7986 0.5 11ZM10.1683 17.5016L15.6683 12.0016C16.222 11.448 16.222 10.552 15.6683 9.99836L10.1683 4.49836C9.61462 3.94468 8.71871 3.94469 8.16503 4.49836C7.61135 5.05204 7.61135 5.94796 8.16503 6.50164L12.6634 11L8.16503 15.4984C7.61135 16.052 7.61135 16.948 8.16503 17.5016C8.4411 17.7777 8.80449 17.9167 9.16667 17.9167C9.52884 17.9167 9.89224 17.7777 10.1683 17.5016Z",
              fill: "white",
              stroke: "#D9D9D9"
            })
          ], -1)
        ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.Days, (day, index) => {
          return _createElementVNode("span", {
            class: "day flex-center",
            key: day,
            style: _normalizeStyle({'--column': index})
          }, _toDisplayString(day), 5)
        }), 64))
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.eventWeeks, (week, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "calendar-row-container",
          key: index
        }, [
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.daysOfWeek($setup.timeframe.year, $setup.timeframe.month, index), (day) => {
              return (_openBlock(), _createElementBlock("div", {
                key: day,
                class: _normalizeClass(["calendar-day-bg flex-center", {'out-of-month': day.getMonth() !== $setup.timeframe.month}])
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["calendar-date flex-center", {'drop-off': $setup.dropOffDate?.valueOf() == day.valueOf(), 'pick-up': $setup.pickUpDate?.valueOf() == day.valueOf()}]),
                  onClick: ($event: any) => ($setup.selectDate(day))
                }, _toDisplayString(day.getDate()), 11, _hoisted_8)
              ], 2))
            }), 128))
          ])
        ]))
      }), 128))
    ]),
    _createElementVNode("footer", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _cache[8] || (_cache[8] = _createElementVNode("span", { class: "description" }, "Dropoff Date:", -1)),
        ($setup.dropOffDate)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("span", _hoisted_11, _toDisplayString($setup.formatDate($setup.dropOffDate)), 1),
              _cache[7] || (_cache[7] = _createElementVNode("span", null, "at", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.dropOffTime) = $event))
              }, [
                _cache[6] || (_cache[6] = _createElementVNode("option", {
                  value: null,
                  hidden: "",
                  disabled: "",
                  selected: ""
                }, "Select a drop off time", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.availableDropOffTimes, (availableDropOffTime) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: availableDropOffTime.getTime(),
                    value: availableDropOffTime
                  }, _toDisplayString($setup.formatTime(availableDropOffTime)), 9, _hoisted_12))
                }), 128))
              ], 512), [
                [_vModelSelect, $setup.dropOffTime]
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      (!$props.singleSelect)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _cache[11] || (_cache[11] = _createElementVNode("span", { class: "description" }, "Pickup Date:", -1)),
            ($setup.pickUpDate)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString($setup.formatDate($setup.pickUpDate)), 1),
                  _cache[10] || (_cache[10] = _createElementVNode("span", null, "at", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.pickUpTime) = $event))
                  }, [
                    _cache[9] || (_cache[9] = _createElementVNode("option", {
                      value: null,
                      hidden: "",
                      disabled: "",
                      selected: ""
                    }, "Select a pick up time", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.availablePickUpTimes, (availablePickUpTime) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: availablePickUpTime.getTime(),
                        value: availablePickUpTime
                      }, _toDisplayString($setup.formatTime(availablePickUpTime)), 9, _hoisted_15))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, $setup.pickUpTime]
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}